export default __webpack_public_path__ + "static/media/calculate.ad607815.svg";